import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OffersDetailsCardProps } from './OffersDetailsCard.types';
import { StyledOffersDetailsCard } from './OffersDetailsCard.styles';
import { OffersDetailsCardWrapper } from './OffersDetailsCardWrapper';

// Use named rather than default exports.
export const OffersDetailsCardConfig = {
  emptyLabel: 'Offers Details Card',
  isEmpty: () => true,
  resourceType: `mi-aem-offers-spa/components/offersdetailscard`,
};

export const OffersDetailsWrapper: React.FC<OffersDetailsCardProps> = props => {
  return <OffersDetailsCardWrapper {...props} />;
};

// Use named rather than default exports.
export const OffersDetailsCard: FC<OffersDetailsCardProps> = props => {
  const isNonEditable = props.cqPath?.includes('experiencefragment');

  const offersDetailsCardWrapper = (
    <StyledOffersDetailsCard
      data-testid="offers-CobrandOffersDetail"
      data-component-name="o-offers-CobrandOffersDetailCard"
    >
      <OffersDetailsWrapper {...props} />
    </StyledOffersDetailsCard>
  );

  return isNonEditable ? (
    offersDetailsCardWrapper
  ) : (
    <EditableComponent config={OffersDetailsCardConfig} {...props}>
      {offersDetailsCardWrapper}
    </EditableComponent>
  );
};
